import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 16,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M207.2,128L48.8,128M113.6,68.6L48.8,128L113.6,187.4"
	})
});
export default SvgArrowLeft;
